import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getLogs ({
    page = 1,
    limit = 30,
    filterByDate,
    filterByAction = [],
    filterByType = [],
    sort = 'date&sort[]=-1',
    search
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, `sort[]=${sort}`]
    if (search) query.push(`search=${search}`)
    if (filterByDate) query.push(`date=${filterByDate}`)
    if (filterByAction.length > 0) query.push(`transactionAction[]=${filterByAction.join('&transactionAction[]=')}`)
    if (filterByType.length > 0) query.push(`transactionType[]=${filterByType.join('&transactionType[]=')}`)
    const url = search ? 'clientlogs' : 'clientlogs/withoutelastic'
    return instCred.get(`${url}?${query.join('&')}`)
  },
  createLog (log) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('clientlogs', log)
  },
  updateLog (log) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('clientlogs/' + log.id, log)
  },
  deleteLog (logId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('clientlogs/' + logId)
  }
}



// WEBPACK FOOTER //
// ./src/api/Logs/api.js